<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 mt-2 pb-2 bgsecond">

                <div class="row   text-light">

                    <div class="col-md-8">

                            <div class="row ">
                                <h1 class=" mt-1 col-md-4 offset-6">
                                    <span v-if="actiontype=='Save'">Enter</span>
                                    <span v-if="actiontype=='Update'">Update</span>
                                    Target Details </h1>
                            </div>
                            <div class="row">
                                <div class="col-md-5">

                                </div>
                                <div class="col-md-3 ">
                                    <label for="" class="form-label">Branch </label>

                                    <v-select
                                        v-model="branch_id"

                                        class="text-dark"
                                        placeholder="Select Branch"
                                        :options="branches"

                                        label="name"
                                        :reduce="option => option.id"

                                    />
                                </div>
                                <div class="col-md-3 ">
                                    <label for="" class="form-label">Month </label>
                                    <v-select
                                        v-model="selectedMonth"

                                        class="text-dark"
                                        placeholder="Select Month"
                                        :options="['January','February','March','April','May','June','July','August','September','October','November','December']"


                                    />

                                </div>


                            </div>

                        <div class="row mt-3">
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-2 ">
                                <label for="" class="form-label">Min Target </label>
                                <b-input v-model="min_target"> </b-input>
                            </div>

                            <div class="col-md-2 ">
                                <label for="" class="form-label">Target </label>
                                <b-input v-model="target"> </b-input>
                            </div>
                            <div class="col-md-2 ">
                                <label for="" class="form-label">High Target </label>
                                <b-input v-model="high_target"> </b-input>
                            </div>



                        </div>




                        <div class="row ">
                            <div class="col-md-4 offset-6">
                                <button  type="button" class="btn custom-btn2 w-100 btn-lg text-light   mt-5 mtmb" @click="save_target" :disabled="!branch_id||!selectedMonth||!min_target||!target||!high_target ||saving ||fetching"> <span v-if="actiontype=='Update'" >Update Target</span>  <span v-if="actiontype=='Save'">Save Target</span> </button>
                            </div>
                        </div>




                    </div>


                </div>



            </div>

        </div>

    </div>

</template>

<script>
import apiService from "@/service/apiService";
import {mapActions, mapState} from "vuex";
import { mapGetters } from 'vuex';
//import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import axios from "axios";
import {cloneDeep} from "lodash";
import Swal from "sweetalert2";
import showrealtime from "@/components/showrealtime";
import URL from "@/constants/baseurl"
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import vSelect from "vue-select";
import moment from "moment";


export default {
    name: "cashierform",

    components:{Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),
        // ...mapState('invoice', ['cashiers']),
        ...mapState('invoice', ['branches']),


        // ...mapState('invoice', ['branches']),
        // totalPages() {
        //     const itemsPerPage = 10;
        //     return Math.ceil(this.filteredOrders.length / itemsPerPage);
        // },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        actiontype(){
            if (this.$route.query.type=='add'){
                return 'Save'
            }
            else if (this.$route.query.type=='edit'){
                return 'Update'
            }
            else {
                return 'View'
            }
        }

    },
    data() {
        return {
            saving:false,
            fetching:false,
            min_target:'',
            target:'',
            high_target:'',
            selectedMonth:'',
            branch_id:'',
            roles: [],
            user: {},
            selectedBranches:[],
            branches:[],




        };
    },
    async created() {
        //  await this.getUsers();
        // await this.getRoles();
        await  this.reloadcb()
        // await this.getcashiers()
        this.viewType = this.$route.query.type;
        this.target_id = this.$route.query.id;
        // console.log("View type:", this.viewType);
        // console.log("Cashier ID:", this.cashier_id);
        this.setTarget()



    },
    async mounted() {


    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),


        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },
        async getbranches(){
            const {data} = await apiService.get(`/branches`);
            console.log('branches', data)
            this.branches=data
        },

        async save_target() {
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                // Set the Authorization header with the API token
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }


            let data={
                branch_id:this.branch_id,
                month:this.selectedMonth,
                min_target:this.min_target,
                target:this.target,
                high_target:this.high_target,
            }
            this.saving=true
            try {
                let api_url=`${URL.BASEURL}/api/create-target`
                if(this.target_id){
                    api_url=`${URL.BASEURL}/api/update-target/${this.target_id}`
                }
                const response = await axios.post(api_url,  data);
                console.log("Target saved:", response.data);
                if(this.target_id){
                    await Swal.fire('Success', 'Target updated successfully!', 'success');
                } else {
                    await Swal.fire('Success', 'Target created successfully!', 'success');
                }

                this.$router.push({ path: '/branch-targets' })



            } catch (error) {
                console.error("Error saving Target:", error);
            }
            finally {
                this.saving=false
            }
        },
        formatDate(date){
            let date1 = new Date(date)
            let date2 = moment(date1).format('MMMM');

            return date2;
        },
        async  setTarget(){
            if(this.viewType!=='add'){
              this.fetching=true
                const {data} = await apiService.get(`/get-target/${this.target_id}`);

                this.branch_id=data.branch_id
                this.min_target=data.min_target
                this.target=data.target
                this.high_target=data.high_target
                this.selectedMonth=this.formatDate(data.month)

                this.fetching=false

            }
        },
    }
};
</script>



<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}



</style>
